import { Drawer, IconButton, styled } from '@mui/material';

export const PanelStyled = styled(Drawer)(({ theme }) => ({
  width: 250,
  flexShrink: 0,
  zIndex: 1000,
  '& .MuiDrawer-paper': {
    paddingTop: 100,
    width: 250,
    boxSizing: 'border-box',
    zIndex: 1029,
  },
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

export const IconButtonStyled = styled(IconButton)({
  padding: 0,
});
